const actions = {
  SET_STATE: 'ai/SET_STATE',
  BOTS_LIST: 'ai/BOTS_LIST',
  GET_BOT: 'ai/GET_BOT',
  ADD_BOT: 'ai/ADD_BOT',
  UPDATE_BOT: 'ai/UPDATE_BOT',
  DELETE_BOT: 'ai/DELETE_BOT',
  CHANGE_BOT_STATUS: 'ai/CHANGE_BOT_STATUS',
  PERSONALITIES_LIST: 'ai/PERSONALITIES_LIST',
  GET_PERSONALITY: 'ai/GET_PERSONALITY',
  ADD_PERSONALITY: 'ai/ADD_PERSONALITY',
  UPDATE_PERSONALITY: 'ai/UPDATE_PERSONALITY',
  DELETE_PERSONALITY: 'ai/DELETE_PERSONALITY',
  CHANGE_PERSONALITY_STATUS: 'ai/CHANGE_PERSONALITY_STATUS',
  GET_SETTINGS: 'ai/GET_SETTINGS',
  UPDATE_SETTINGS: 'ai/UPDATE_SETTINGS',
  AI_LIST: 'ai/AI_LIST',
  UPDATE_AI_FEATURE: 'ai/UPDATE_AI_FEATURE',
}

export default actions
